import React from "react";

const BitcoinIcon = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill="#F7931A"
    />
    <path
      d="M23.1892 14.02C23.5032 11.924 21.9062 10.797 19.7242 10.045L20.4322 7.205L18.7042 6.775L18.0142 9.54C17.5602 9.426 17.0942 9.32 16.6292 9.214L17.3242 6.431L15.5962 6L14.8882 8.839C14.5122 8.753 14.1422 8.669 13.7842 8.579L13.7862 8.57L11.4022 7.975L10.9422 9.821C10.9422 9.821 12.2252 10.115 12.1982 10.133C12.8982 10.308 13.0242 10.771 13.0032 11.139L12.1972 14.374C12.2452 14.386 12.3072 14.404 12.3772 14.431L12.1942 14.386L11.0642 18.918C10.9782 19.13 10.7612 19.449 10.2712 19.328C10.2892 19.353 9.01523 19.015 9.01523 19.015L8.15723 20.993L10.4072 21.554C10.8252 21.659 11.2352 21.769 11.6382 21.872L10.9232 24.744L12.6502 25.174L13.3582 22.334C13.8302 22.461 14.2882 22.579 14.7362 22.691L14.0302 25.519L15.7582 25.949L16.4732 23.083C19.4212 23.641 21.6372 23.416 22.5702 20.75C23.3222 18.604 22.5332 17.365 20.9822 16.558C22.1122 16.298 22.9622 15.555 23.1892 14.02V14.02ZM19.2392 19.558C18.7062 21.705 15.0912 20.544 13.9192 20.253L14.8692 16.448C16.0412 16.741 19.7982 17.32 19.2392 19.558ZM19.7742 13.989C19.2872 15.942 16.2792 14.949 15.3042 14.706L16.1642 11.256C17.1392 11.499 20.2822 11.952 19.7742 13.989Z"
      fill="white"
    />
  </svg>
);

export default BitcoinIcon;
